module.exports = __webpack_public_path__ + "img/jcb.52d14fdd.svg";